var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2378)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A9612C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2093 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2093 2 32.0001 2Z",
    fill: "#F17B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0056 11.99H16.2806V10.82C16.7506 10.82 17.1256 10.78 17.4056 10.7C17.6956 10.62 17.9256 10.49 18.0956 10.31C18.2656 10.12 18.4156 9.85 18.5456 9.5H19.6556V20H18.0056V11.99ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM24.4986 18.86C24.4986 18.11 24.6186 17.47 24.8586 16.94C25.0986 16.4 25.5286 15.805 26.1486 15.155C26.7586 14.505 27.1786 13.95 27.4086 13.49C27.6486 13.03 27.7686 12.55 27.7686 12.05C27.7686 11.6 27.6936 11.29 27.5436 11.12C27.4036 10.94 27.1936 10.85 26.9136 10.85C26.3436 10.85 26.0586 11.195 26.0586 11.885V13.01H24.4986V11.99C24.4986 11.14 24.7086 10.49 25.1286 10.04C25.5486 9.58 26.1586 9.35 26.9586 9.35C27.7586 9.35 28.3686 9.58 28.7886 10.04C29.2086 10.49 29.4186 11.14 29.4186 11.99C29.4186 12.63 29.2636 13.255 28.9536 13.865C28.6536 14.475 28.1286 15.175 27.3786 15.965C26.8886 16.485 26.5586 16.91 26.3886 17.24C26.2186 17.56 26.1336 17.905 26.1336 18.275V18.5H29.2686V20H24.4986V18.86Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2378",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2378"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2378",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/1-2.840abe80bcb433c5ee8167e86276a21a.svg";
export { ForwardRef as ReactComponent };